import { render } from "./NewsDetailView.vue?vue&type=template&id=448c1e70&ts=true"
import script from "./NewsDetailView.vue?vue&type=script&lang=ts"
export * from "./NewsDetailView.vue?vue&type=script&lang=ts"

import "./NewsDetailView.vue?vue&type=style&index=0&id=448c1e70&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__